import './Counter.2503b3f8c6e2c7fe3e47c0b1837a6437.css';
export default {"counter":"_counter_nmxfk_1","plusIcon":"_plusIcon_nmxfk_1","minusIcon":"_minusIcon_nmxfk_1"};